<template >
  <div>
    <el-upload
      ref="upload"
      :auto-upload="true"
      :data="access"
      :action="action"
      accept='.jpg,.jpeg,.png,.gif,.doc,.docx,.txt,.xls,.xlsx,.pdf'
      :multiple="true"
      :before-upload="beforeUpload"
      :on-remove="onRemoveHandler"
      :before-remove="beforeRemove"
      :on-success="onSuccessHandler"
      :on-error="onError"
      :show-file-list="false"
      :on-preview="handlePreview"
      :disabled="IsUpload==false"
      :on-exceed="fileLimit"
      :limit = '8'
      drag
    >
      <i class="el-icon-upload"></i>
    </el-upload>
    <div>
      <el-col :span="8" v-for="(item,index) in sourceFiles" :key="index">
        <el-card shadow="hover">
          <span @click="see(item.url,item.status)">{{item.title}}</span>
          <!-- <a href="http://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/y8FdfX3Xa5XJBmk6.xls?response-content-disposition=attachment;filename=北京中物联物流采购培训中心培训讲师申请表.doc" class="a-download-text">点击下载</a> -->
        </el-card>
      </el-col>
    </div>

    <el-dialog :close-on-click-modal="false" title="预览" :visible.sync="dialogVisiblePreviewResources" width="45%" :append-to-body="true">
      <img :src="imgUrl" alt="" class="preview-class-content">
      <span slot="footer" class="dialog-footer">
        <el-button @click="pre()">上一页</el-button>
        <el-button @click="next()">下一页</el-button>
        <el-button @click="dialogVisiblePreviewResources = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import Vue from 'vue';
import uploader from "lib/mixins/uploader";
export default {
  mixins: [uploader],
  props: {
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      docId: "",
      sourceFiles: [],
      materialids: [],
      dialogVisiblePreviewResources: false,
      imgsList: [],
      imgUrl: "",
      indexCount: 0
    };
  },
  created(){
  },
  methods: {
    uploadFile() {},
    dialogClose() {},
    fileLimit(){
      this.$message.warning("一次最多上传8个文件");
    },
    beforeUpload(file) {
      debugger;
      const ext = file.name.split('.').pop()

      return ['jpg','jpeg','png','gif','doc','docx','txt','xls','xlsx','pdf'].includes(ext) && this.addFile(file);
    },
    onRemoveHandler(file) {},
    beforeRemove(file, fileList) {},
    handlePreview(file) {},
    onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      this.$http
        .post("/api/XOrg/AttestationActivity/getScreenCourseWareInfo", {
          courseWareId: res.docId
        })
        .then(function(rst) {
          var data = [];
          // 判断是否是单张图片
          if (rst.category != "jpg" && rst.category != "jpeg" && rst.category != "png" && rst.category != "gif") {
            var imgs = [];

            var statusUrl = rst.urls.preview_oss_gen;

            // 拼接图片的地址
            for (var i = 0; i < rst.args_page_count; i++) {
              data.push(statusUrl + (i + 1) + ".png");
            }
          } else {
            data = [res.docPath];
          }

          that.sourceFiles.push({
            title: res.fileName,
            url: data,
            status: rst.status
          });

          console.log(that.sourceFiles);
        });

      this.IsShowUpload = false;
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
      }
      this.materialids.push(res.docId);
      this.$emit("done", this.materialids);
    },
    see(url,status){
      if(status == 1){
        this.dialogVisiblePreviewResources = true;
        this.imgsList = url
        this.imgUrl = url[0];
      }else{
        this.$message.warning("文件正在转换，请稍等");
      }
      
    },
    pre(){
      if(this.indexCount > 0){
        this.indexCount -= 1;
        this.imgUrl = this.imgsList[this.indexCount];
      }
    },
    next(){
      if(this.indexCount < this.imgsList.length){
        this.indexCount += 1;
        this.imgUrl = this.imgsList[this.indexCount];
      }
    }
  }
};
</script>

<style lang="scss">
.PreviewResourcces {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2010;
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  overflow: auto;
  .icon-closeimg {
    size: 26px;
    position: fixed;
    top: 20px;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
  }
}
.el-col-8 {
  margin-top: 15px;
  width: 100%;
}
.preview-class-content{
  max-width: 100%;
}
</style>
